import React, { useState } from 'react';
import './styles';
import { useDispatch, useSelector } from 'react-redux';
import Helmet from 'react-helmet';
import RegionOptions from './RegionOptions/RegionOptions';
import RegionConfig from './RegionConfig/RegionConfig';
import Queries from '../../../../../utils/API/Queries';
import UIDropdownSelect from '../../../../../components/UI/UIDropdownSelect';
import UILabeledInput from '../../../../../components/UI/UILabeledInput';
import RegionServiceArea from '../Regions/RegionServiceArea/RegionServiceArea';
import UIController from '../../../../../components/UI/UIController';
import { UI_LABELED_INPUT_DROPDOWN_TYPE } from '../../../../../components/UI/UILabeledInput/config';
import { AdminRegionsProps } from './types';
import { TABS } from './config';
import { getCurrentUserSelector } from '../../../../../redux/selectors/CurrentUserSelectors';
import { setSelectedRegion } from '../../../../../redux/store/user/actions';
import { useQuery } from 'react-apollo';

export default function AdminRegions({}: AdminRegionsProps) {
	const currentUser = useSelector(getCurrentUserSelector);
	const dispatch = useDispatch();

	const [flyTo, setFlyTo] = useState<Function>();
	const [selectedTab, setSelectedTab] = useState(TABS.LIST);

	const { data: regionsData } = useQuery(Queries.GET_REGIONS_QUERY);

	if (!regionsData?.regions) return null;

	if (!currentUser.selectedRegion) {
		dispatch(setSelectedRegion(regionsData.regions[0]));
	}

	const renderTabComponent = () => {
		const { selectedRegion } = currentUser;

		const renderTabBar = () => {
			if (!selectedRegion) return null;

			return (
				<UIDropdownSelect
					containerClassName='regionsTabBar'
					selectedTab={selectedTab}
					tabs={[TABS.LIST, TABS.ZIPS, TABS.REGIONS]}
					updateSelected={setSelectedTab}
				/>
			);
		};

		return (
			<div className='adminRegionsTabs'>
				<UILabeledInput
					type={UI_LABELED_INPUT_DROPDOWN_TYPE}
					options={regionsData.regions.map((region) => {
						return { value: region, label: region.name };
					})}
					onChangeDropdownValue={(value) => {
						dispatch(setSelectedRegion(regionsData.regions.filter((region) => region.id === value.value.id)[0]));
						setTimeout(async () => {
							if (flyTo) {
								flyTo([currentUser.selectedRegion.longitude, currentUser.selectedRegion.latitude]);
							}
						}, 10);
					}}
					value={selectedRegion && { value: selectedRegion, label: selectedRegion.name }}
					placeholder='Select a region'
					className='regionDropdown'
				/>
				{renderTabBar()}
			</div>
		);
	};

	const getPageComponent = () => {
		switch (selectedTab.value) {
			case TABS.ZIPS.value:
				return <RegionServiceArea setFlyTo={setFlyTo} />;
			case TABS.LIST.value:
				return <RegionOptions selectedRegionId={currentUser.selectedRegion?.id ?? ''} />;
			case TABS.REGIONS.value:
				return <RegionConfig selectedRegionId={currentUser.selectedRegion?.id ?? ''} />;
			default:
				return undefined;
		}
	};

	return (
		<UIController bodyClassName='uiMenu__body--content'>
			<Helmet>
				<title>Regions | Pineapple Labs</title>
				<meta property='og:title' content='Regions | Pineapple Labs' />
			</Helmet>
			{renderTabComponent()}
			{getPageComponent()}
		</UIController>
	);
}
